export default __webpack_public_path__ + "static/media/1981.03d7bf25.png";